import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const styles = {
  line: (backgroundColor: string, color: string) => ({
    backgroundColor,
    color,
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '10px',
    fontFamily: 'monospace',
  }),
  textarea: {
    backgroundColor: token(
      'color.background.accent.green.subtlest',
      colors.G50
    ),
    color: token('color.text.accent.green', colors.G500),
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid',
    width: '100%',
    height: '50px',
    fontSize: '16px',
    marginBottom: '10px',
  },
};
